// Same pub/sub shape as gameReset.ts/radialMeasure.ts: the Developer Tools "Room
// Jump" buttons (in ui.ts) tell the running GameScene to teleport the player to a
// room's default spawn point, without a direct reference to the scene. Dev-only --
// bypasses door locks and any story gating entirely, on purpose.

const listeners: Array<(roomId: string) => void> = [];

export function onRoomJump(listener: (roomId: string) => void): void {
  listeners.push(listener);
}

export function triggerRoomJump(roomId: string): void {
  listeners.forEach((listener) => listener(roomId));
}
